import { takeLatest, put } from 'redux-saga/effects';
import { setUsers, setUser, fetchUsers, fetchUser, appNotify } from 'store/actions';
import { getWithToken } from 'api/network';

export function* getUsersSaga() {
    yield takeLatest(fetchUsers, function* () {
        try {
            const res = yield getWithToken(`/api/clientUsers`);
            const data = yield res.json();
            yield put(setUsers(data));
        } catch (error) {
            yield put(appNotify(error.message, 'error'));
        }
    });
}

export function* getUserSaga() {
    yield takeLatest(fetchUser, function* () {
        try {
            const res = yield getWithToken(`/api/clientusers/whoami`);
            const data = yield res.json();
            data.roles = data.userRoles.reduce((result, role) => {
                result[role.roleName.charAt(0).toLowerCase() + role.roleName.slice(1)] = role.isOktaRole;
                return result;
              }, {});
            yield put(setUser(data));
        } catch (error) {
            yield put(appNotify(error.message, 'error'));
        }
    });
}